"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));
var _chartHelper = require("./chartHelper");
var _Legend = _interopRequireDefault(require("./Legend"));
var _ChartTooltip = _interopRequireDefault(require("./ChartTooltip"));
var _excluded = ["width", "height", "innerRadius", "outerRadius", "data", "dataKey", "dataUnit", "nameKey", "color", "filled", "labels", "innerLabels", "paddingAngle", "legend", "tooltip", "pieOptions"];
var RADIAN = Math.PI / 180;
var PieChart = function PieChart(props) {
  var width = props.width,
    height = props.height,
    innerRadius = props.innerRadius,
    outerRadius = props.outerRadius,
    data = props.data,
    dataKey = props.dataKey,
    dataUnit = props.dataUnit,
    nameKey = props.nameKey,
    color = props.color,
    filled = props.filled,
    labels = props.labels,
    innerLabels = props.innerLabels,
    paddingAngle = props.paddingAngle,
    legend = props.legend,
    tooltip = props.tooltip,
    pieOptions = props.pieOptions,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var renderInnerLabel = function renderInnerLabel(_ref) {
    var cx = _ref.cx,
      cy = _ref.cy,
      midAngle = _ref.midAngle,
      innerRadius = _ref.innerRadius,
      outerRadius = _ref.outerRadius,
      percent = _ref.percent,
      index = _ref.index,
      value = _ref.value;
    var radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    var x = cx + radius * Math.cos(-midAngle * RADIAN);
    var y = cy + radius * Math.sin(-midAngle * RADIAN);
    return /*#__PURE__*/_react["default"].createElement("text", {
      x: x,
      y: y,
      fill: "white",
      textAnchor: x > cx ? 'start' : 'end',
      dominantBaseline: "central"
    }, "".concat(value, " ").concat(dataUnit));
  };
  var renderLabels = function renderLabels(entry) {
    return "".concat((0, _isFunction["default"])(dataKey) ? dataKey(entry) : entry[dataKey], " ").concat(dataUnit);
  };
  var pieLabel = labels && (innerLabels ? renderInnerLabel : renderLabels);
  return /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
    width: width,
    height: height
  }, /*#__PURE__*/_react["default"].createElement(_recharts.PieChart, remainingProps, legend && /*#__PURE__*/_react["default"].createElement(_recharts.Legend, (0, _extends2["default"])({
    formatter: function formatter(value, entry) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-color-darker"
      }, value);
    }
  }, legend.props)), /*#__PURE__*/_react["default"].createElement(_recharts.Pie, (0, _extends2["default"])({
    data: data,
    isAnimationActive: true,
    nameKey: nameKey,
    dataKey: dataKey,
    label: pieLabel
    // cx={Math.max(outerRadius, width / 3)}
    // cy={height / 2}
    ,
    innerRadius: filled ? 0 : innerRadius,
    outerRadius: outerRadius,
    paddingAngle: filled ? 0 : paddingAngle,
    labelLine: !innerLabels
  }, pieOptions), data.map(function (entry, index) {
    var cellColor = (0, _chartHelper.getColor)(entry.color) || (0, _chartHelper.getFromDefaultColors)(index);
    return /*#__PURE__*/_react["default"].createElement(_recharts.Cell, {
      key: "cell-".concat(index),
      fill: (0, _isFunction["default"])(color) ? (0, _chartHelper.getColor)(color(entry, index)) : cellColor
    });
  })), tooltip && /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, (0, _extends2["default"])({
    formatter: function formatter(value) {
      return "".concat(value, " ").concat(dataUnit);
    }
  }, tooltip.props))));
};
PieChart.defaultProps = {
  width: '100%',
  height: 250,
  innerRadius: 60,
  outerRadius: 80,
  data: [],
  dataKey: 'value',
  dataUnit: '',
  nameKey: 'name',
  // color,
  filled: false,
  labels: true,
  innerLabels: false,
  paddingAngle: 3,
  // pieOptions,
  legend: /*#__PURE__*/_react["default"].createElement(_Legend["default"], null),
  tooltip: /*#__PURE__*/_react["default"].createElement(_ChartTooltip["default"], null)
};
var _default = PieChart;
exports["default"] = _default;